import React from 'react';

import styles from './styles';
import { Box } from '@material-ui/core';

import { Placeholder, PlaceholderCarIcon } from '@cobliteam/base-components';

const DropdownVehiclesPlaceholder = () => (
  <Box className={styles.placeholder}>
    <Placeholder Icon={PlaceholderCarIcon} text='Nenhum veículo encontrado.' />
  </Box>
);

export default DropdownVehiclesPlaceholder;
